import { createFileRoute } from '@tanstack/react-router';
import { PhotoToAnimationRoute } from '@/components/custom/photo-to-animation-route';
import { getPhotoToAnimationSeoData } from '@/components/custom/photo-to-animation-seo-data';
import { seo } from '@/lib/seo';
import { validateVideoSearch } from '@/lib/video-route-search';

export const Route = createFileRoute('/photo-to-animation')({
  validateSearch: validateVideoSearch,
  head: () => {
    const data = getPhotoToAnimationSeoData();
    return seo(data.path, {
      title: data.seoTitle,
      description: data.seoDescription,
      keywords: data.keywords,
    });
  },
  component: PhotoToAnimationRoute,
});
